// 3rd-party modules
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

// project modules
import type { RootState, AppDispatch } from '../stores';

// use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
